export class MessageReactionDto {
    constructor(messageId, receiverReaction) {
        this.messageId = messageId;
        this.receiverReaction = receiverReaction;
    }
}
